import { render, staticRenderFns } from "./fuzai.vue?vue&type=template&id=2318d5a8&scoped=true&"
import script from "./fuzai.vue?vue&type=script&lang=js&"
export * from "./fuzai.vue?vue&type=script&lang=js&"
import style0 from "./fuzai.vue?vue&type=style&index=0&id=2318d5a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318d5a8",
  null
  
)

export default component.exports